import { render } from "./Committed.vue?vue&type=template&id=44d8f0f0&lang=pug"
import script from "./Committed.vue?vue&type=script&lang=js"
export * from "./Committed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__